<template> 
      <div :id="targetId" oncontextmenu="return false;">
        <div v-if="!this.$attrs.control.isReadOnly && !NoteIsVoid && !this.$attrs.IsChartReview && !this.isReadOnly">
          <ejs-contextmenu  :id="targetId" :target="menuItems.length > 0 ? menuTargetId : null" :items='menuItems' :select='onSelect'></ejs-contextmenu>
        </div>
        <input
            v-mask="this.maskValue"
            v-b-tooltip.hover :title="Hint"
            :type="Type"
            :maxlength="this.$attrs.control.controlMaxLenght"          
            :readonly="this.$attrs.control.isReadOnly || NoteIsVoid || this.$attrs.control.IsChartReview || this.isReadOnly"
            :min="Min"
            :max="Max"           
            :step="StepProp"
            :ref="RefProp"          
            :class="classValue" 
            :formatter="OnFormatter"
            v-bind:value="Value"
            v-on:blur="OnBlur($event)"
            v-on:change="OnChange"
            v-on:keyup.enter="$emit('keyup', $event)"
            :aria-describedby="this.$attrs.control.controlID"           
            v-on:keypress="$emit('keypress', $event)"
            v-on:input="Input"
            v-on:focus="$emit('focus', $event.target.value)"
            v-bind:style="style"
            :id="idControl"
            >
            <!-- <VueContext ref="menu">
                <a class="dropdown-item" @click="showModalGetLastAnswers()">
                  Get 10 Last Answers
                </a>
            </VueContext> -->
            <MdGetLastAnswers v-if="showGetLastAnswers"
              v-bind:ShowPopup="showGetLastAnswers"
              @getCancel="onCancelGetLastAnswers($event)"
              @getOK="onOKGetLastAnswers($event)"
              v-bind:ControlId="controlID"
              v-bind:PatientCode="PatientCode"
              v-bind:TransDate="TransDate"
            />
      </div>         
</template>

<script>
import { EventBus } from '../../event-bus.js';
import Vue from 'vue';
import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";
import Utils from '@/common/utils'


Vue.use(ContextMenuPlugin);
export default {
  name: 'MdMaskEdit',
  mixins: [EventBus],
   props: {   
     StepProp:String,    
     isReadOnly:Boolean,
     Formatter:Function,
     Min:String,
     Max:String,
     Change:Function,
     RefProp:String,
     KeyEnter:Function,
     KeyPress:Function,
     FeedBackText:String,
     Name:String,
     value:[String, Number],
     TransDate: String,
     NoteId: String,
     id: [String, Number],
     PatientCode: String,
     IsCommonPart: Boolean,
     IsGroupContainer: Boolean
   },

   data(){
     return{
      classValue:"form-control cursor-context-menu",
      NoteIsVoid:false,
      CountInput:0,
      style:{
        position:'absolute',
        top: this.$attrs.control.controlTop+'px',
        width:this.$attrs.control.controlWidth+'px',
        height:this.$attrs.control.controlHeight+'px',
        left:this.$attrs.control.controlLeft+'px',
        fontSize:'',
        fontWeight: '',
        fontFamily:'',
        color:'',
        backgroundColor:'',
        textDecorationLine:'',
        fontStyle:'',
        textTransform:'',
        borderColor: '',
        textAlign: 'left'
      },
      Hint: this.$attrs.control.controlHint,
      Type: 'text',
      isRequired: this.$attrs.control.isRequired,
      showGetLastAnswers: false,
      controlID:String(this.$attrs.control.controlID),
      //PatientCode: this.$route.params.id,
      Value: this.value,
      maskValue:'',
      menuItems:[],
      targetId: "target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
      menuTargetId:"#target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
      idControl:this.id.toString(),
      invalid: false
     }
   },

   watch: {
        value: function(newModel) {
            this.Value = newModel;
        },
    },


methods:{
     OnChange(evt){
       this.$emit('change',evt.target.value)
       this.style.borderColor = ((evt.target.value.length == 0 && this.isRequired) || this.invalid) ? '#dc3545 !important': ''
     },

     OnFormatter(valueIn,valueOu) {
       this.Formatter(valueIn,valueOu);
       this.$emit('Formatter',valueOu)
     },

     OnBlur(evt){
       this.$emit('blur',evt.target.value)
       this.style.borderColor = ((evt.target.value.length == 0 && this.isRequired) || this.invalid) ? '#dc3545 !important': ''
     },

     ChangeValue(value) {
        this.$emit('input', value);
        var changed = {
            "ControlId":this.$attrs.control.controlID,
            "Changed":true,
            "NoteId":this.NoteId
        }
        EventBus.$emit('onControlWasChanged', changed);
        this.style.borderColor = value.length == 0 && this.isRequired ? '#dc3545 !important': ''
     },

     setControlType() {
       let controlDataType = this.$attrs.control.controlDataType;
       if(controlDataType === 'Integer' || controlDataType === 'Money')
        this.Type = 'number'
       if(controlDataType === 'String')
        this.Type = 'text'
     },

     setControlCharCase() {
       let controlCharCase = this.$attrs.control.controlCharCase;
       if(controlCharCase === 'ecUpperCase')
        this.style.textTransform = 'uppercase'
       if(controlCharCase === 'ecLowerCase')
        this.style.textTransform = 'lowercase'
     },

     setAlignment() {
       if(this.$attrs.control.alignment) {
          if(this.$attrs.control.alignment === 'taCenter')
            this.style.textAlign = 'center'
          if(this.$attrs.control.alignment === 'taLeftJustify')
            this.style.textAlign = 'left'
          if(this.$attrs.control.alignment === 'taRightJustify')
            this.style.textAlign = 'right'
       }
     },

     InitializeVariables(){
       if(this.$attrs.control.controlColorForHtml)
          this.style.backgroundColor = this.$attrs.control.controlColorForHtml;
       else if(this.$attrs.control.isReadOnly || this.isReadOnly)
          this.style.backgroundColor = '#e9ecef !important'
       if(this.$attrs.control.controlFontForHtml){         
          this.controlFont = this.$attrs.control.controlFontForHtml.split(',');
          var size = parseInt(this.controlFont[1]) + 2;
          this.style.fontFamily = this.controlFont[0];
          this.style.fontSize = size+'px !important';
          this.style.color = this.controlFont[3];
          var Decorations = this.controlFont[2];
          this.style.fontWeight = Decorations.charAt(0) === '1'?'bold':'';
          this.style.fontStyle = Decorations.charAt(1) === '1'?'italic':'';
          this.style.textDecorationLine = Decorations.charAt(2) === '1'?'underline':'';
          this.style.textDecorationLine = Decorations.charAt(3) === '1'?this.style.textDecorationLine+ ' line-through':this.style.textDecorationLine;
       }
       if(this.$attrs.control.controlMask){
         this.maskValue = this.getMaskValue(this.$attrs.control.controlMask)
       }
       this.validateInput(this.value);
       this.setControlType();
       this.setControlCharCase();
       this.setAlignment()
    },

    showModalGetLastAnswers() {
      this.showGetLastAnswers = true
    },

    onCancelGetLastAnswers(){
      this.showGetLastAnswers = false
    },

    Input(w){     
      // control Mask to allow only numbers and decimals. Example !9999999999.99;1;_
      // It will allow any amount of digits in the int part and up to 2 digits for the decimal
      // we have to implement the decimal mask in the input event because if we apply a fixed control mask like ###.## it will force to have 3 digits or spaces in the int part
      if (/^!9+\.[9]+;1;_$/.test(this.$attrs.control.controlMask)){
        let value = w.target.value
          .replace(/[^0-9.]/g, '')       // remove non-digits except '.'
          .replace(/(\..*)\./g, '$1');   // only one dot allowed

        // Limit to 2 decimals if '.' exists
        if (value.includes('.')) {
          const [intPart, decPart] = value.split('.');
          value = intPart + '.' + decPart.slice(0, 2);
        }

        w.target.value = value;
      }
        
      this.validateInput(w.target.value);
      this.Value = w.target.value;

      this.$emit('input', w.target.value);
      this.CountInput++;
      if(w.target.value.length > 0 && this.CountInput > 1){
        var changed = {
        "ControlId":this.$attrs.control.controlID,
        "Changed":true,
        "NoteId":this.NoteId
        }
        EventBus.$emit('onControlWasChanged', changed);
      }
    },

    onOKGetLastAnswers(value) {
      this.Value = value;
      this.$emit('input', value);
       var changed = {
        "ControlId":this.$attrs.control.controlID,
        "Changed":true,
        "NoteId":this.NoteId
        }
      EventBus.$emit('onControlWasChanged', changed);
      this.showGetLastAnswers = false;
    },

    handlerClick(evt){
      if(!this.$attrs.control.isReadOnly && !this.isReadOnly) {
        this.$refs.menu.open(evt)
      }
    },

    setValid(state){
        this.style.borderColor = state ? '#dc3545 !important': ''
    },

    setRequired(value) {
      this.isRequired = value;
      if (!value) {
        this.style.borderColor = '';
      } else if (this.Value === null || this.Value === undefined || this.Value.length === 0) {
          this.style.borderColor = '#dc3545 !important';
      }
    },

    getMaskValue(controlMask){
      let maskValue = ''
      if(controlMask == '!99/99/0000;1;_') {
        maskValue = '##/##/####'
      }
      else if(controlMask == '!90:00;1;_') {
        maskValue = '##:##'
      }
      else if(controlMask == '!90:00> LL;1;_') {
        maskValue = '##:## AA'
      }
      else if(controlMask == '!90:00:00> LL;1;_') {
        maskValue = '##:##:## AA'
      }
      else if(controlMask == '!99/99/0000 !90:00> LL;1;_') {
        maskValue = '##/##/#### ##:## AA'
      }
      else if(controlMask == '!99/99/00;0;_') {
        maskValue = '##/##/##'
      }
      //Mask to enter only numbers. The format of the mask will be like !9999999999;1;_ with any amount of 9 to specify the max number of characters allowed. 
      else if(/^!9+;1;_$/.test(controlMask)) { 
        maskValue = Utils.convertIntegerMask(controlMask)
      }
      //The masks to allow numbers with decimals is implemented in the input event.

      return maskValue
    },

    validateInput(controlValue) {
      this.invalid = false;
      if (!Utils.isNullOrEmptyString(controlValue)) {
        const controlMask = this.$attrs.control.controlMask;
        if(controlMask == '!99/99/0000;1;_') {
          // date format '##/##/####'
          this.invalid = !Utils.IsValidDateAndRange(controlValue, Utils.getShortDateFormat(), true);
        }
        else if(controlMask == '!90:00;1;_') {
          // 24-hour format without seconds: HH:mm
          const short24h = /^(?:[01]?[0-9]|2[0-3]):[0-5][0-9]$/;
          this.invalid = !short24h.test(controlValue);
        }
        else if(controlMask == '!90:00> LL;1;_') {
          // 12-hour format without seconds: hh:mm AM/PM
          const short12h = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?[APap][Mm]$/;
          this.invalid = !short12h.test(controlValue);
        }
        else if(controlMask == '!90:00:00> LL;1;_') {
          // 12-hour format with seconds: hh:mm:ss AM/PM
          const long12h = /^(0[1-9]|1[0-2]):[0-5][0-9]:[0-5][0-9]\s?[APap][Mm]$/;
          this.invalid = !long12h.test(controlValue);
        }
        else if(controlMask == '!99/99/0000 !90:00> LL;1;_') {
          // date format '##/##/#### ##:## AA'
          this.invalid = !Utils.IsValidDateAndRange(controlValue, Utils.getDateTimeFormat(), true);
        }
        else if(controlMask == '!99/99/00;0;_') {
          // date format '##/##/##'
          this.invalid = !Utils.IsValidDateAndRange(controlValue, Utils.getDateWithShortYearFormat(), true);
        }
      }
    },

    onSelect: function(args ) {
       if(args.item.id === 'gettenlastans') {
         this.showModalGetLastAnswers()
       }
    },

    loadMenuItems() {
      this.menuItems = []
      if (!this.IsCommonPart) {
        this.menuItems.push({text: this.$t('Shared.GetLast10'), id: "gettenlastans"})
      }
    },

    isValid() {
      return !this.invalid;
    }
},

created(){

    EventBus.$on("onSetReadOnly", function (e,id) {
      if(this.$attrs.HeaderId === id){
        this.NoteIsVoid = e;
      }
      }.bind(this));

  if(this.$attrs.NoteIsVoid){
    this.NoteIsVoid = this.$attrs.NoteIsVoid;
  }

},
mounted(){
  this.InitializeVariables();
  this.loadMenuItems()

  if (!this.IsCommonPart && this.IsGroupContainer && this.$attrs.control.isCommonControlNote) {
    this.Hint = this.$t('GroupNotesDashboard.ToCompletedInGroupFocus')
  }
}
};

</script>

<style>
 @import '../../assets/css/Patients/Patient.css';
 .scroll{
	overflow: hidden !important;
}
</style>


